import { render, staticRenderFns } from "./BackupMonetaryTable.vue?vue&type=template&id=b27e57e8&"
import script from "./BackupMonetaryTable.vue?vue&type=script&lang=js&"
export * from "./BackupMonetaryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports